export default __webpack_public_path__ + "static/media/VTC-logo.d07fc00d.png";